import { Button, Dialog, DialogActions, DialogContent, DialogContentText, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DialogHeader } from '@omnea-app/omui/DialogHeader'
import { OrgConfigIssue } from '../../hooks/useOrgConfigIssuesBannerInfo'
import { OrgConfigIssueRow } from './OrgConfigIssueRow'

type Props = {
  isOpen: boolean
  issues: OrgConfigIssue[]
  onClose: () => void
  onSnooze: () => void
}

export const ReviewSetupDialog = ({ isOpen, issues, onClose, onSnooze }: Props) => {
  const { t } = useTranslation('common', { keyPrefix: 'org-config-issues.dialog' })

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogHeader title={t('title')} onClose={onClose} />
      <DialogContent sx={{ gap: 4 }}>
        <DialogContentText>{t('description')}</DialogContentText>
        <Stack gap={2}>
          {issues.map((issue) => (
            <OrgConfigIssueRow key={issue.key} issue={issue} />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="secondary" onClick={onSnooze}>
          {t('snooze')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
